export default [
    {
        path: "/payment/dashboard",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.dashboard.dashboard.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-dashboard', to: null, class: 'text-dark' },
              { text: 't-overview', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/dashboard/index.vue")
    },
    {
        path: "/payment/merchants",
        name: "merchants",
        meta: {
            title: "Merchants",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.merchant.merchants.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-settings', to: null, class: 'text-dark' },
              { text: 't-merchants', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/merchants/index.vue")
    },
    {
        path: "/payment/merchant-transactions",
        name: "merchant-transactions",
        meta: {
            title: "Merchant Transactions",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.merchant.transactions.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-merchant-transactions', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/merchantTransactions/index.vue"),
    },
    {
        path: "/payment/payment-accounts",
        name: "payment-accounts",
        meta: {
            title: "Payment Accounts",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.accounts.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-settings', to: null, class: 'text-dark' },
              { text: 't-payment-accounts', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentAccounts/index.vue"),
    },
    {
        path: "/payment/payment-groups",
        name: "payment-groups",
        meta: {
            title: "Payment Groups",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.groups.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-settings', to: null, class: 'text-dark' },
              { text: 't-payment-groups', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentGroups/index.vue"),
    },
    {
        path: "/payment/payment-account-transactions",
        name: "payment-account-transactions",
        meta: {
            title: "Payment Account Transactions",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.account-transactions.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-payment-account-transactions', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentAccountTransactions/index.vue"),
    },
    {
        path: "/payment/payment-provider-transactions",
        name: "payment.payment-provider-transactions",
        meta: {
            title: "Payment Provider Transactions",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment-provider.transactions.view',
            application: 'payment-application',
          breadcrumb: () => [
            { text: 't-transactions', to: null, class: 'text-dark' },
            { text: 't-payment-provider-transactions', to: null }
          ]
        },
        component: () => import("@/views/paymentManagements/paymentProviderTransactions/index.vue"),
    },
    {
        path: "/payment/payment-account-live-balances",
        name: "payment-account-live-balances",
        meta: {
            title: "Payment Account Live Balance Summary",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.accounts.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-reports', to: null, class: 'text-dark' },
              { text: 't-live-payment-account-balance-summary', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentAccountLiveBalances/index.vue"),
    },
    {
        path: "/payment/deposits",
        name: "deposits",
        meta: {
            title: "Deposits",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.transaction.deposits.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-deposits', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/deposits/index.vue"),
    },
    {
        path: "/payment/withdrawals",
        name: "withdrawals",
        meta: {
            title: "Withdrawals",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.transaction.withdraws.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-withdrawals', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/withdrawals/index.vue"),
    },
    {
        path: "/payment/payment-account-daily-reports",
        name: "payment-account-daily-reports",
        meta: {
            title: "Payment Account Daily Report",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.report.payment-account-daily-reports.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-reports', to: null, class: 'text-dark' },
              { text: 't-payment-account-daily-reports', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentAccountDailyReports/index.vue"),
    },
    {
        path: "/payment/merchant-daily-reports",
        name: "merchant-daily-reports",
        meta: {
            title: "Merchant Daily Report",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.report.merchant-daily-reports.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-reports', to: null, class: 'text-dark' },
              { text: 't-merchant-daily-reports', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/merchantDailyReports/index.vue"),
    },
    {
        path: "/payment/summary-reports",
        name: "summary-reports",
        meta: {
            title: "Summary Report",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.report.summary-reports.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-reports', to: null, class: 'text-dark' },
              { text: 't-summary-report', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/summaryReports/index.vue"),
    },
    {
        path: "/payment/bank-transactions",
        name: "bank-transactions",
        meta: {
            title: "Bank Transactions",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.bank.transactions.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-bank-transactions', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/bankTransactions/index.vue"),
    },
    {
        path: "/payment/unclaimed-transactions",
        name: "unclaimed-transactions",
        meta: {
            title: "Unclaimed Transactions",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.account-transactions.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-unclaimed-transactions', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/unclaimedTransactions/index.vue"),
    },
    {
        path: "/payment/unclaimed-transactions/:uuid",
        name: "unclaimed-transactions-claim",
        meta: {
            title: "Unclaimed Transaction",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.account-transactions.view',
            application: 'payment-application',
            breadcrumb: (route) => [
              { text: 't-transactions', to: null, class: 'text-dark' },
              { text: 't-unclaimed-transactions', to: { name: 'unclaimed-transactions' } },
              { text: route.params.uuid, to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/unclaimedTransactions/claim.vue"),
    },
    {
        path: "/payment/payment-rate-limit-usage",
        name: "payment-rate-limit-usage",
        meta: {
            title: "Payment Rate Limit Usage",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.report.payment-rate-limit-usages.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-reports', to: null, class: 'text-dark' },
              { text: 't-payment-rate-limit-usage', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentRateLimitUsage/index.vue"),
    },
    {
        path: "/payment/transaction-types-and-groups",
        name: "transaction-types-and-groups",
        meta: {
            title: "Transaction Types & Groups",
            authRequired: true,
            resource: 'Tenant',
            action: ['pas.transaction.transaction-type-groups.view', 'pas.transaction.transaction-types.view'],
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-settings', to: null, class: 'text-dark' },
              { text: 't-transaction-types-and-groups', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/transactionTypesAndGroups/index.vue"),
    },
    {
        path: "/payment/payment-layer-logs",
        name: "payment-layer-logs",
        meta: {
            title: "Payment Layer Log",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.payment.layers.view',
            application: 'payment-application',
            breadcrumb: () => [
              { text: 't-reports', to: null, class: 'text-dark' },
              { text: 't-payment-layer-logs', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/paymentLayerLogs/index.vue"),
    },
    {
        path: "/payment/export-tasks",
        name: "export-tasks",
        meta: {
            title: "Export Tasks",
            authRequired: true,
            resource: 'Tenant',
            action: 'pas.transaction.export-tasks.view',
            application: 'payment-application',
            breadcrumb: () => [
                { text: 't-transactions', to: null, class: 'text-dark' },
                { text: 't-export-tasks', to: null }
            ]
        },
        component: () => import("@/views/paymentManagements/exportTasks/index.vue"),
    },
];
